import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class dpPullUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    fetchResult(req) {
        return this.repo.getDpPullEmail(req);
    }
}
export default dpPullUseCase;
